document.addEventListener("DOMContentLoaded", function(event) {

  let wallCount = 1;
  const initWallCount = 1;

  var rowTemplate = '<label for="length1Wall%1$s">Length of %1$s%2$s wall</label><div class="form__group length-row"><div class="form__item"><div class="form__item__input"><input class="length1" id="length1Wall%1$s" type="text" value=""><div class="form__item__label uom-box">%3$s</div></div></div><div class="form__item"><div class="form__item__input"><input class="length2" id="length2Wall%1$s" type="text" value=""><div class="form__item__label uom-box">%4$s</div></div></div></div>';

  function calcAddWall() {
      wallCount++;
      let Unit1 = '';
      let Unit2 = '';
      const calcAddWallMeasurement = document.getElementById("measurement_select").value;

      Unit1 = 'ft';
      Unit2 = 'in';

      const additionalWallRows = document.getElementById("additionalWallRows");
      additionalWallRows.insertAdjacentHTML('beforeend', sprintf(rowTemplate, wallCount, nth(wallCount), Unit1, Unit2));
  }

  function nth(d) {
      d -= 0;

      if (d > 3 && d < 21) return 'th';

      switch (d % 10) {
          case 1:
              return "st";
          case 2:
              return "nd";
          case 3:
              return "rd";
          default:
              return "th";
      }
  }

  function wallPaperCalcUnitsChangeFunc() {
      wallPaperCalcResetFields();
      const unit1 = document.getElementById("measurement_select").value === "Metric" ? 'm' : 'ft';
      const unit2 = document.getElementById("measurement_select").value === "Metric" ? 'cm' : 'in';

      document.querySelectorAll('.uom-box').forEach(function (element, index) {
          element.innerHTML = index % 2 === 0 ? unit1 : unit2;
      });

      document.querySelector('.uom-box:last-child').innerHTML = unit2;

      if (document.getElementById("measurement_select").value === "Metric") {
          document.querySelector(".measurement-block").classList.remove('imperial');
      } else {
          document.querySelector(".measurement-block").classList.add('imperial');
      }
  }

  function wallPaperCalcEstimate() {
      let height = 0;
      let height1 = 0;
      let height2 = 0;
      let length = 0;
      let length1 = 0;
      let length2 = 0;
      let calcUnits = 0;
      let cutCount = 0;
      let totalLength = 0;
      let rollCount = 0;

      if (document.getElementById("measurement_select").value === "Metric") {
          calcUnits = 1;
      }

      height1 = document.getElementById("height1").value;
      height2 = document.getElementById("height2").value;

      if (height1 === '') height1 = 0;
      if (height2 === '') height2 = 0;

      height1 = parseInt(height1);
      height2 = parseInt(height2);

      if (calcUnits) {
          height1 *= 100;
      } else {
          height1 *= 12;
      }

      height = height1 + height2;

      if (!calcUnits) {
          //height *= 2.54;
      }

      for (let i = 1; i <= wallCount; i++) {
          let fieldID = "length1Wall" + i;
          length1 = document.getElementById(fieldID).value;
          fieldID = "length2Wall" + i;
          length2 = document.getElementById(fieldID).value;

          if (length1 === '') length1 = 0;
          if (length2 === '') length2 = 0;

          length1 = parseInt(length1);
          length2 = parseInt(length2);

          if (calcUnits) {
              length1 *= 100;
          } else {
              length1 *= 12;
          }

          length += length1 + length2;
      }

      if (!calcUnits) {
          //length *= 2.54;
      }

      const area = height * length;
      const rollsHeight = area / 70;
      rollCount = Math.ceil(rollsHeight / 1000);

      if (isNaN(rollCount)) {
          alert('Please enter valid Height and Length.');
      } else {
          document.getElementById("wallPaperCalcOutput").value = rollCount;
      }
  }

 function wallPaperCalcEstimateNew() {
    const calcType = document.querySelector('.calculator').dataset.type;
    let isMetric;
    let multiplier;
    let hcRollsSize = document.querySelector('#hc-rolls-size').value;

    let rollWidth;
    let rollFullLength;

    if (hcRollsSize == '24W x 27L') {
        rollWidth = 24;
        rollFullLength = 324;
    } else {
        rollWidth = 24;
        rollFullLength = 156;
    }

    if (document.getElementById('measurement_select').value === "Metric") {
        isMetric = true;
    } else {
        isMetric = false;
    }

    if (isMetric) {
        multiplier = 100;
    } else {
        multiplier = 12;
    }

    let height1 = parseCustom(document.getElementById('height1').value, isMetric);
    let height2 = parseCustom(document.getElementById('height2').value, isMetric);
    let height = (multiplier * height1) + height2;

    let width = 0;

    document.querySelectorAll('.length-row').forEach(function (row) {
        const width1 = parseCustom(row.querySelector('.length1').value, isMetric);
        const width2 = parseCustom(row.querySelector('.length2').value, isMetric);
        width += (multiplier * width1) + width2;
    });

    let totalSets = Math.ceil((width * height) / (rollFullLength * rollWidth));
    let hcWaste = 0.1;
    let aux = Math.ceil(totalSets * hcWaste);
    totalSets += aux;

    // Apply adjustment only for 24W x 27L rolls
    if (hcRollsSize === '24W x 27L') {
        totalSets = totalSets > 1 ? totalSets - 1 : totalSets;
    }

    document.getElementById('wallPaperCalcOutput').value = totalSets;
}

  function parseCustom(value, isMetric) {
      value = parseFloat(value);
      if (isNaN(value)) {
          value = 0;
      }
      /*
      if (!isMetric) value *= 2.54;*/
      return value;
  }

  function wallPaperCalcReset() {
      wallPaperCalcResetFields();
  }

  function wallPaperCalcResetMeasurements() {
      document.getElementById("measurement_select").value = "Metric";
      document.getElementById('measurement_select').dispatchEvent(new Event('change'));
  }

  function wallPaperCalcResetFields() {
      document.getElementById("wallPaperCalcOutput").value = "";
      document.getElementById("height1").value = "";
      document.getElementById("height2").value = "";

      for (let i = 1; i <= wallCount; i++) {
          let fieldID = "length1Wall" + i;
          document.getElementById(fieldID).value = "";
          fieldID = "length2Wall" + i;
          document.getElementById(fieldID).value = "";
      }

      wallCount = initWallCount;
      document.getElementById("additionalWallRows").innerHTML = "";
  }
  function sprintf () {
      const regex = /%%|%(?:(\d+)\$)?((?:[-+#0 ]|'[\s\S])*)(\d+)?(?:\.(\d*))?([\s\S])/g
      const args = arguments
      let i = 0
      const format = args[i++]
      const _pad = function (str, len, chr, leftJustify) {
        if (!chr) {
          chr = ' '
        }
        const padding = (str.length >= len) ? '' : new Array(1 + len - str.length >>> 0).join(chr)
        return leftJustify ? str + padding : padding + str
      }
      const justify = function (value, prefix, leftJustify, minWidth, padChar) {
        const diff = minWidth - value.length
        if (diff > 0) {
          // when padding with zeros
          // on the left side
          // keep sign (+ or -) in front
          if (!leftJustify && padChar === '0') {
            value = [
              value.slice(0, prefix.length),
              _pad('', diff, '0', true),
              value.slice(prefix.length)
            ].join('')
          } else {
            value = _pad(value, minWidth, padChar, leftJustify)
          }
        }
        return value
      }
      const _formatBaseX = function (value, base, leftJustify, minWidth, precision, padChar) {
        // Note: casts negative numbers to positive ones
        const number = value >>> 0
        value = _pad(number.toString(base), precision || 0, '0', false)
        return justify(value, '', leftJustify, minWidth, padChar)
      }
      // _formatString()
      const _formatString = function (value, leftJustify, minWidth, precision, customPadChar) {
        if (precision !== null && precision !== undefined) {
          value = value.slice(0, precision)
        }
        return justify(value, '', leftJustify, minWidth, customPadChar)
      }
      // doFormat()
      const doFormat = function (substring, argIndex, modifiers, minWidth, precision, specifier) {
        let number, prefix, method, textTransform, value
        if (substring === '%%') {
          return '%'
        }
        // parse modifiers
        let padChar = ' ' // pad with spaces by default
        let leftJustify = false
        let positiveNumberPrefix = ''
        let j, l
        for (j = 0, l = modifiers.length; j < l; j++) {
          switch (modifiers.charAt(j)) {
            case ' ':
            case '0':
              padChar = modifiers.charAt(j)
              break
            case '+':
              positiveNumberPrefix = '+'
              break
            case '-':
              leftJustify = true
              break
            case "'":
              if (j + 1 < l) {
                padChar = modifiers.charAt(j + 1)
                j++
              }
              break
          }
        }
        if (!minWidth) {
          minWidth = 0
        } else {
          minWidth = +minWidth
        }
        if (!isFinite(minWidth)) {
          throw new Error('Width must be finite')
        }
        if (!precision) {
          precision = (specifier === 'd') ? 0 : 'fFeE'.indexOf(specifier) > -1 ? 6 : undefined
        } else {
          precision = +precision
        }
        if (argIndex && +argIndex === 0) {
          throw new Error('Argument number must be greater than zero')
        }
        if (argIndex && +argIndex >= args.length) {
          throw new Error('Too few arguments')
        }
        value = argIndex ? args[+argIndex] : args[i++]
        switch (specifier) {
          case '%':
            return '%'
          case 's':
            return _formatString(value + '', leftJustify, minWidth, precision, padChar)
          case 'c':
            return _formatString(String.fromCharCode(+value), leftJustify, minWidth, precision, padChar)
          case 'b':
            return _formatBaseX(value, 2, leftJustify, minWidth, precision, padChar)
          case 'o':
            return _formatBaseX(value, 8, leftJustify, minWidth, precision, padChar)
          case 'x':
            return _formatBaseX(value, 16, leftJustify, minWidth, precision, padChar)
          case 'X':
            return _formatBaseX(value, 16, leftJustify, minWidth, precision, padChar)
              .toUpperCase()
          case 'u':
            return _formatBaseX(value, 10, leftJustify, minWidth, precision, padChar)
          case 'i':
          case 'd':
            number = +value || 0
            // Plain Math.round doesn't just truncate
            number = Math.round(number - number % 1)
            prefix = number < 0 ? '-' : positiveNumberPrefix
            value = prefix + _pad(String(Math.abs(number)), precision, '0', false)
            if (leftJustify && padChar === '0') {
              // can't right-pad 0s on integers
              padChar = ' '
            }
            return justify(value, prefix, leftJustify, minWidth, padChar)
          case 'e':
          case 'E':
          case 'f': // @todo: Should handle locales (as per setlocale)
          case 'F':
          case 'g':
          case 'G':
            number = +value
            prefix = number < 0 ? '-' : positiveNumberPrefix
            method = ['toExponential', 'toFixed', 'toPrecision']['efg'.indexOf(specifier.toLowerCase())]
            textTransform = ['toString', 'toUpperCase']['eEfFgG'.indexOf(specifier) % 2]
            value = prefix + Math.abs(number)[method](precision)
            return justify(value, prefix, leftJustify, minWidth, padChar)[textTransform]()
          default:
            // unknown specifier, consume that char and return empty
            return ''
        }
      }
      try {
        return format.replace(regex, doFormat)
      } catch (err) {
        return false
      }
    }

    const hcCalcTrigger = document.querySelector('.hc-calculator-trigger');
    const hcCalcClose = document.querySelector('.hc-drawer-close');
    const hcOverlay = document.querySelector('.hc-overlay');
    const hcBody = document.querySelector('body');
    const hcAddWall = document.querySelector('.hc-add-wall');
    const hcEstimate = document.querySelector('.hc-estimate');
    const hcReset = document.querySelector('.hc-reset');

    
    hcCalcTrigger.addEventListener('click', e => {
        const hcDrawer = document.querySelector('.hc-calculator-drawer');
        hcDrawer.classList.add('drawer--open');
        hcOverlay.classList.add('hc-overlay-active');  
        hcBody.classList.add('hc-calculator-active');
    });
    hcCalcClose.addEventListener('click', e => {
        const hcDrawer = document.querySelector('.hc-calculator-drawer');
        hcDrawer.classList.remove('drawer--open');
        hcOverlay.classList.remove('hc-overlay-active');
        hcBody.classList.remove('hc-calculator-active');
    });
    hcAddWall.addEventListener('click', e => {
        calcAddWall();
    });

    hcEstimate.addEventListener('click', e => {
        wallPaperCalcEstimateNew();
    });

    hcReset.addEventListener('click', e => {
        wallPaperCalcReset();
    });

});